import { runtimeEnv } from 'config/runtimeEnv';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
import { setCustomerComplaint } from '../utils/utils';

let env = runtimeEnv('B2B_API_BASE_URL');

export const customerComplaintApi = async (data) => {
  console.log('customerComplaintApi', data);
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = `${env}${
    API_ENDPOINT.CustomerComplaints.api +
    '?isB2B=true&status=' +
    data?.status +
    '&page=' +
    page +
    '&pageSize=' +
    data?.pageSize +
    '&search=' +
    (data?.search ? data?.search : '') +
    '&location=' +
    (data?.location ? data?.location : '') +
    '&complainType=' +
    (data?.complainType ? data?.complainType : '')
  }`;
  if (data?.id) {
    url = `${env}${API_ENDPOINT.CustomerComplaints.apiById + '/' + data.id}?isB2B=true`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);

  // console.log("customerComplaintApi", res);
  return setCustomerComplaint(res);
};

// New API: updateComplaintApi
export const updateComplainApi = async (id, payload) => {
  // console.log("updateComplaintApi", id, payload);
  const url = `${env}${API_ENDPOINT.CustomerComplaints.updateComplainApi + '/' + id}?isB2B=true`;

  const res = await requestInstance.post(url, payload).catch((err) => err.response);

  // console.log("updateComplaintApi Response", res);
  return setCustomerComplaint(res);
};
